import * as React from "react";

import { cn } from "~/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "ekv:file:text-foreground ekv:placeholder:text-muted-foreground ekv:selection:bg-primary ekv:selection:text-primary-foreground ekv:dark:bg-input/30 ekv:border-input ekv:h-9 ekv:w-full ekv:min-w-0 ekv:rounded-md ekv:border ekv:bg-transparent ekv:px-3 ekv:py-1 ekv:text-base ekv:shadow-xs ekv:transition-[color,box-shadow] ekv:outline-none ekv:file:inline-flex ekv:file:h-7 ekv:file:border-0 ekv:file:bg-transparent ekv:file:text-sm ekv:file:font-medium ekv:disabled:pointer-events-none ekv:disabled:cursor-not-allowed ekv:disabled:opacity-50 ekv:md:text-sm",
        "ekv:focus-visible:border-ring ekv:focus-visible:ring-ring/50 ekv:focus-visible:ring-[3px]",
        "ekv:aria-invalid:ring-destructive/20 ekv:dark:aria-invalid:ring-destructive/40 ekv:aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
